/**
 * Route Constants - TEK KAYNAK
 * Tüm route'lar burada tanımlı
 * Link oluştururken SADECE buradan kullan
 */

export const ROUTES = {
  // Public pages
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',

  // Social pages
  SOCIAL: '/social',
  SOCIAL_FOLLOWING: '/social/following',
  SOCIAL_SAVED: '/social/saved',
  SOCIAL_POST: (id: number | string) => `/social/post/${id}`,
  ASK_AI: '/ask-ai',

  // Main pages
  DASHBOARD: '/dashboard',
  PROJECTS: '/projects',
  PROJECTS_LISTING: '/projects-listing',
  AGENTS: '/agents',
  AGENTS_LISTING: '/agents-listing',

  // Detail pages (fonksiyon ile ID ekle)
  PROJECT_DETAIL: (id: number | string) => `/projects/${id}`,
  AGENT_DETAIL: (id: number | string) => `/agent/${id}`,
  EXPERT_DETAIL: (id: number | string) => `/experts/${id}`,
  USER_PROFILE: (username: string) => `/profile/${username}`,

  // Agent pages
  MY_AGENTS: '/my-agents',
  CREATE_AGENT: '/agents/create',
  EDIT_AGENT: (id: number | string) => `/agents/${id}/edit`,

  // Project pages
  PROJECT_WORKSPACE: (id: number | string) => `/project/${id}/workspace`,
  CREATE_PROJECT: '/projects/create',

  // Admin pages
  ADMIN: '/admin',
  ADMIN_API_KEYS: '/admin/api-keys',
  ADMIN_FLZHUB: '/admin/flzhub',

  // Work pages
  WORK: '/work',
  WORK_CREATE: '/work/create',
  WORK_DETAIL: (id: number | string) => `/work/${id}`,
  WORK_CATEGORIES: '/work/categories',

  // Special pages
  FLZHUB_CHAT: '/flzhub/chat',
  SETTINGS: '/settings',
  HELP: '/help',
  ABOUT: '/about',
} as const

/**
 * KULLANIM ÖRNEKLERİ:
 *
 * // Link oluştur
 * navigate(ROUTES.AGENT_DETAIL(agent.id))
 *
 * // Route tanımla (App.tsx)
 * <Route path="/agent/:id" element={<AgentDetail />} />
 *
 * // Link component
 * <Link to={ROUTES.AGENT_DETAIL(1)}>Agent 1</Link>
 */
